import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactDOM from 'react-dom';
import './styles.css'; 
import logo from '../../../..//src/assets/images/logo.jpeg'
import * as mui from '@mui/material';
import Cookies from 'js-cookie'

const ClientSideBar = ({ mainContent }) => {
    const [drawerPos, setDrawerPos] = useState(1);
    const navigate = useNavigate();

    const handleDrawer = () => {
        if (drawerPos < 2) {
            setDrawerPos(drawerPos + 1);
        } else {
            setDrawerPos(0);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        Cookies.remove('token');
        localStorage.removeItem('refresh_token');
        Cookies.remove('refresh_token');
        Cookies.remove('groups');
        Cookies.remove('csrftoken');
        Cookies.remove('audit_role');
        window.location.href = '/login';
    };

    let drawerClass = [];
    let mainClass = [];

    if (drawerPos === 1) {
        drawerClass.push('drawerMin');
        mainClass.push('mainMin');
    } else if (drawerPos === 2) {
        drawerClass.push('drawerOpen');
        mainClass.push('mainOpen');
    }

    return (
        <div className="App">
            <navbar>
                <i className="material-icons" onClick={handleDrawer}>
                    menu
                </i>
            
                <a className="navbar-brand" href="/" style={{ marginLeft: '10px' }}>
                    <img src={logo} width="35" height="35" className="d-inline-block align-top" alt="" />
                    <span className="menu-collapsed" style={{ marginLeft: '10px', fontSize: '25px', color: 'white' }}>Audit-AI</span>
                </a>
            </navbar>
            <aside className={drawerClass.join(' ')}>
                <ul>
                    <li onClick={() => navigate('/dashboard')}>
                        <i className="material-icons">folder_special</i>
                        <span>Requests Dashboard</span>
                    </li>

                    <li onClick={handleLogout}>
                        <i className="material-icons">logout</i>
                        <span>Logout</span>
                    </li>
                </ul>
            </aside>

            <main className={mainClass.join(' ')}>
                {mainContent}
            </main>
        </div>
    );
};

export default ClientSideBar;
